import _ from "lodash"

// If these are encountered as the 'company_id' it should be replaced w/ sonicu.
const SONICU_ROOT_ROUTES = [
        'enterprise-dashboard',
        'device-association',
        'probe-calibration',
        'probe-association',
        'shipping-checklist',
        'sites',
        'scripts',
        'enhanced-audits',
        'SonicuTools',
        'probe-association',
        'probe-calibration',
        'shipping-checklist',
        'data-concentrator',
        'operations',
        'production',
        'engineering',
        'export-users',
        'multi-point-calibration-profiles',
        'investigation-engine',
        'api'
]

export class CompanyHelper {
    buildCompanyRoute(route, company = null) {
        company = _.isNil(company)
                ? this.getCompanyId()
                : company
        return `/${company}/${route}`;
    }

    buildCompanyApiInternalRoute(route, company = null) {
        company = _.isNil(company)
                ? this.getCompanyId()
                : company
        return `/api-internal/${company}/${route}`;
    }

    getCompanyId(parentSite = 'sonicu') {
        let path = window.location.pathname.split('/');
        let companyId = path[1]

        return SONICU_ROOT_ROUTES.indexOf(companyId) !== -1
                ? parentSite
                : companyId
    }

    buildRoute(route) {
        return `/${route}`
    }

    buildApiInternalRoute(route) {
        return `/api-internal/${route}`
    }


}